<div class="main-container">
  <div class="main-container-bg" style="position: absolute; top: 0; left: 0; right: 0; z-index: -1"></div>
  <section class="container p-0">
    <div class="row m-0">
      <!-- sidebar left with search, ratings and co -->
      <div class="col-12 col-lg-4" style="padding-left: 15px; padding-right: 15px">
        <div class="d-md-block">
          <app-shop-search
            #search
            (sentForm)="updateForm($event)"
            (changedPersons)="updatePersons($event)"
            (changedLocation)="updateLocation($event)"
            (changedDateRange)="updateTimerange($event)"
            (changedPromocode)="updatePromocode($event)"
            [implementationPage]="'townPage'" />

          @defer (when displayDesktopElements && shops.length > 3) {
            @if (displayDesktopElements && shops.length > 3) {
              <app-shop-filter [shops]="shops" />
            }
          }

          @if (
            !bookingParameters.partner &&
            displayDesktopElements &&
            platformInformationService.getCurrentPlatformShortcode() === 'ar'
          ) {
            <div style="min-height: 150px">
              @defer (on viewport) {
                <app-trustpilot />
              } @placeholder {
                <div></div>
              }
            </div>
          }

          @if (displayDesktopElements) {
            <div class="card mb-2">
              <div class="card-header text-danger">
                <app-icon name="phone" height="24px" width="24px" class="mr-2" />
                <strong>{{ 'ALPINSKIHIRE.sidebar.hotline' | alpitranslate }}</strong>
              </div>
              <div class="card-body helpline d-flex justify-content-between">
                <div>{{ 'ALPINSKIHIRE.sidebar.hotlineItalic' | alpitranslate }}</div>
                @if (hotlines) {
                  <div>
                    <span [innerHTML]="'ALPINSKIHIRE.sidebar.callNow' | alpitranslate"></span>
                    <a [href]="'tel://' + hotlines[translateService.currentLang]">
                      <strong>{{ hotlines[translateService.currentLang] }}</strong>
                    </a>
                  </div>
                }
              </div>
            </div>
            @defer (on viewport) {
              <app-payment-methods />
            } @placeholder {
              <div></div>
            }
          }

          @if (platformInformationService.getCurrentPlatformShortcode() === 'ar' && displayDesktopElements) {
            <div class="card mb-2">
              <div class="card-header text-danger">
                <app-icon name="review" class="mr-2" width="1.5rem" height="1.5rem" />
                <strong>{{ 'SHOPLIST.advantagesHeadline' | alpitranslate }}</strong>
              </div>
              @defer (on viewport) {
                <app-shop-list-advantages [xscontainer]="true" />
              } @placeholder {
                <div></div>
              }
            </div>
          }
        </div>
      </div>
      <!-- sidebar left with search, ratings and co end -->
      <!-- main content with shoplist, town infos-->
      <div class="col-12 col-lg-8 px-lg-2 p-0">
        <h1 class="no-teaser-headline" data-test="searchResultHeadline">
          {{ 'SHOPLIST.' + teaserHeadline | alpitranslate: { town_name: town ? town.name : '---' } }}
        </h1>
        @defer (when displayDesktopElements) {
          @if (displayDesktopElements) {
            <app-shop-sort
              (updatedSort)="sortShops($event)"
              [displayDesktopElements]="displayDesktopElements" />
          }
        }
        <div class="mt-4 mt-md-2">
          @if (platformInformationService.getCurrentPlatformShortcode() !== 'es') {
            <div class="items-count-wrapper text-uppercase d-lg-none">
              <span>{{ shops.length }} </span>
              <span>{{ 'SHOPLIST.results' | alpitranslate: { pluralate: shops.length } }}</span>
            </div>
          }
          <!-- shoplist -->
          @if (!loading && !error) {
            <div #shopList class="shoplist">
              <!-- shop loop -->
              @for (
                shop of shopFilterService.filterBy(
                  shops,
                  shopFilterService.distance(),
                  shopFilterService.activeFilters()
                );
                track shopTrackedBy(i, shop);
                let i = $index
              ) {
                <div
                  [attr.data-slug]="translateService.currentLang + '/' + bookingParameters.slug"
                  class="the_shop_pile"
                  [class.topshop]="shop.isTopShop"
                  [class.isTopShop]="shop.isTopShop"
                  [class.isDiscountShop]="shop.isDiscountShop"
                  [class.not-in-town]="!shop.inTown"
                  [class.child-free]="shop.hasFreeChildren"
                  [class.no-offer-available]="shop.isOfferAvailable"
                  [class.unbookable]="
                    shop?.unbookableReasonsFor(
                      bookingParameters.start,
                      bookingParameters.end,
                      bookingParameters.ages
                    ).length
                  "
                  id="scroll-shop-{{ shop.id }}"
                  [preRender]="i < 2"
                  (deferLoad)="showShop(shop)">
                  @if (shop.lazyshow === true || i === 0 || skipDeferLoading) {
                    <app-shop
                      [bookingParameters]="bookingParameters"
                      [shop]="shop"
                      [showAdditionalElements]="showAdditionalElements"
                      [showAlpinFlexiBadge]="showFreeFlexi"
                      [userDefinedSearch]="bookingParameters.userDefinedSearch"
                      [isLoadingNewPriceData]="shopSearchHelperService.loadingInTown"
                      [isLoadingNewOutOfTownPriceData]="shopSearchHelperService.loadingOutOfTown"
                      [freeFlexiUntil]="freeFlexiUntil"
                      [sortBy]="shopSortingService.getCurrentSelection()" />
                  }
                </div>
              }
            </div>
          }
          <!-- loading shops -->
          @defer (when loading) {
            @if (loading) {
              <div>
                @for (item of [0, 1, 2]; track item) {
                  <div class="row w-100 ml-0 mr-0 town-card d-flex mb-2 p-lg-2">
                    <div class="col-12 col-sm-6 col-md-3 col-lg-4 p-0 col-image p-sm-1 d-flex flex-column">
                      <div class="image-wrapper h-100 ng-star-inserted">
                        <ng-container class="ng-star-inserted">
                          <app-skeleton-loader
                            [loaderHeight]="'235px'"
                            class="col-sm-4 ml-0 mr-0 px-0 teaser-pic" />
                        </ng-container>
                        <div class="w-100"></div>
                      </div>
                    </div>
                    <div class="town-card-content-wrapper col-12 col-sm-6 col-md-9 col-lg-8 pr-1">
                      <div class="row d-flex h-100 no-gutters pt-1">
                        <div class="col-12 col-md-6 col-lg-5 d-flex flex-column">
                          <div class="shop-details-wrapper p-2 p-lg-0 d-flex flex-column">
                            <div class="shop-title">
                              <app-skeleton-loader class="d-flex" />
                            </div>
                            <div class="address">
                              <app-skeleton-loader
                                [loaderWidth]="'75%'"
                                [loaderHeight]="'22px'"
                                class="d-sm-flex mb-2 d-none" />
                              <app-skeleton-loader
                                [loaderWidth]="'75%'"
                                [loaderHeight]="'11px'"
                                class="d-sm-flex my-1 d-none" />
                              <app-skeleton-loader
                                [loaderWidth]="'75%'"
                                [loaderHeight]="'11px'"
                                class="d-sm-flex mt-1 mb-3 d-none" />
                              <app-skeleton-loader
                                [loaderWidth]="'40%'"
                                [loaderHeight]="'11px'"
                                class="d-sm-flex mt-2 mb-3 d-none" />
                            </div>
                            <div class="map-link d-sm-flex d-none">
                              <app-skeleton-loader
                                [loaderWidth]="'36px'"
                                [loaderHeight]="'24px'"
                                class="d-flex mr-1" />
                              <app-skeleton-loader
                                [loaderWidth]="'36px'"
                                [loaderHeight]="'24px'"
                                class="d-flex mr-1" />
                              <app-skeleton-loader
                                [loaderWidth]="'36px'"
                                [loaderHeight]="'24px'"
                                class="d-flex mr-1" />
                              <app-skeleton-loader
                                [loaderWidth]="'36px'"
                                [loaderHeight]="'24px'"
                                class="d-flex" />
                            </div>
                          </div>
                          <div class="store-benefits mt-auto mb-2 d-none d-md-block">
                            <app-skeleton-loader
                              [loaderWidth]="'35%'"
                              [loaderHeight]="'11px'"
                              class="d-flex mt-1 mb-3" />
                            <app-skeleton-loader
                              [loaderWidth]="'75%'"
                              [loaderHeight]="'11px'"
                              class="d-flex my-1" />
                            <app-skeleton-loader
                              [loaderWidth]="'75%'"
                              [loaderHeight]="'11px'"
                              class="d-flex my-1" />
                            <app-skeleton-loader
                              [loaderWidth]="'75%'"
                              [loaderHeight]="'11px'"
                              class="d-flex my-1" />
                            <div class="title mb-1 d-flex flex-row align-items-center">
                              <div class="d-none d-sm-block" style="font-size: 1rem"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-7 pl-md-3 d-flex flex-column">
                          <div class="special-info-wrapper d-none d-sm-flex">
                            <app-skeleton-loader
                              [loaderWidth]="'40%'"
                              [loaderHeight]="'22px'"
                              class="d-flex pr-2" />
                            <app-skeleton-loader
                              [loaderWidth]="'75%'"
                              [loaderHeight]="'11px'"
                              class="d-flex pr-2 mt-2" />
                            <app-skeleton-loader
                              [loaderWidth]="'75%'"
                              [loaderHeight]="'11px'"
                              class="d-flex pr-2 mt-1" />
                          </div>
                          <div class="d-block mt-auto ng-star-inserted">
                            <div class="mt-auto ng-star-inserted">
                              <div class="row mb-2 discount-details">
                                <div class="col col-6 text-center">
                                  <app-skeleton-loader [loaderHeight]="'22px'" class="d-flex" />
                                </div>
                                <div class="col col-6 text-center ng-star-inserted">
                                  <app-skeleton-loader [loaderHeight]="'22px'" class="d-flex pr-2" />
                                </div>
                              </div>
                              <div class="pl-md-0 pb-3 pr-2">
                                <app-skeleton-loader [loaderHeight]="'44px'" class="d-flex" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }
          @if (error && !loading) {
            <div class="col-lg-12 product clearfix">
              @if (saleslocationNotFound) {
                @if (saleslocationNotFound.strict.length > 0 || saleslocationNotFound.similar.length > 0) {
                  <p class="town404">
                    {{ 'SHOPLIST.townNotFound' | alpitranslate: { slug: saleslocationNotFound.slug } }}
                  </p>
                } @else {
                  <p class="town404">
                    {{
                      'SHOPLIST.townNotFoundNoSuggestions'
                        | alpitranslate: { slug: saleslocationNotFound.slug }
                    }}
                  </p>
                }
                @if (saleslocationNotFound.strict.length > 0 || saleslocationNotFound.similar.length > 0) {
                  <ul>
                    @for (proposal of saleslocationNotFound.strict.slice(0, 4); track proposal) {
                      <li>
                        <a href="{{ proposal.url }}">{{ proposal.name }}</a>
                      </li>
                    }
                    @for (proposal of saleslocationNotFound.similar.slice(0, 4); track proposal) {
                      <li>
                        <a href="{{ proposal.url }}">{{ proposal.name }}</a>
                      </li>
                    }
                  </ul>
                }
              }
              @if (saleslocationEmpty) {
                @if (town) {
                  <p class="town404">
                    {{ 'SHOPLIST.saleslocationEmpty' | alpitranslate: { name: town.name } }}
                  </p>
                }
                @if (!town) {
                  <p class="town404">
                    {{ 'SHOPLIST.saleslocationEmptyGeneric' | alpitranslate }}
                  </p>
                }
              }
              @if (error && !loading && !saleslocationNotFound && !saleslocationEmpty) {
                <a (click)="retryLoad()">{{ 'SHOPLIST.tryReloadShopList' | alpitranslate }}</a>
              }
            </div>
          }
          <!-- shopliste end -->
        </div>
        <!-- town footer with disclaimer block start -->
        @defer (when !loading && showTownFurtherInformation && town) {
          @if (!loading && showTownFurtherInformation && town) {
            <footer class="article-footer">
              @if (isBrowser) {
                <app-disclaimers
                  [bookingParameters]="bookingParameters"
                  [showGroupDiscountFootnote]="showGroupDiscountFootnote"></app-disclaimers>
              }
              <app-town-further-info [town]="town" [lang]="culture"></app-town-further-info>
            </footer>
          }
        }
        <!-- town footer with disclaimer block end -->
      </div>
      <!-- main content with shoplist, town infos end -->
    </div>
  </section>
</div>
